module.exports = __webpack_public_path__ + "img/logo-vertical-en.9b4b3cd5.png";